declare global {
  interface NetworkInformation {
    effectiveType?: string;
    downlink?: number;
    rtt?: number;
  }

  interface Navigator {
    connection?: NetworkInformation;
  }
}

export function getNetworkInfo() {
  if (!navigator.connection) {
    return undefined;
  }

  return {
    effectiveType: navigator.connection.effectiveType,
    downlink: navigator.connection.downlink,
    rtt: navigator.connection.rtt,
  };
}
